import _ from "lodash";
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useImperativeHandle,
  useCallback,
} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import withLoader from "UIComponents/GqlWithLoader";
import Loading from "UIComponents/Loading";
import I18nHOC from "UIComponents/I18nHOC";
import NoDataComponent from "UIComponents/NoDataComponent";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import BreadCrumbs from "UIComponents/BreadCrumbs";
import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";
import { getAssessmentOfUnitQuery } from "Assessments/modules/AssessmentQuery";
import { checkScrollAtBottom } from "services/checkScrollAtBottom";
import {
  convertDurationToString,
  getRethumbUrl,
  prepareLoadMoreFeed,
  getLabelValueForMultiFilterLabelButton,
  getMediaCardFileType,
  getThumbUrl,
  getStyleStrippedText,
  getThumbnailIcon,
  getArchivedText,
  htmlToText,
  onEnterOrSpaceKeyDown,
  getMemoizedFunction,
  getKeyboardFocusableElements,
} from "Utils";
import {
  getSelectedAcademicYearId,
  getUserArchivalStatus,
} from "modules/CommonSelectors";
import {
  PLACEHOLDER_SQUARE_IMAGE_COUNT,
  PLACEHOLDER_SQUARE_IMAGE,
  colors,
} from "Constants";
import classes from "./LeFeed.scss";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { MoreFilters } from "AppComponents/LeFeed/MoreFilters";
import { MoreFiltersBar } from "AppComponents/LeFeed/MoreFiltersBar";
import { withLELibraryFilters } from "SchoolLibrary/routes/LELibrary/modules/HOC";
import { withToddleLibraryFilters } from "ToddleLibrary/modules/HOC";
import {
  FILTER_NAME_ACADEMIC_YEAR,
  FILTER_NAME_GRADES,
  FILTER_NAME_CREATORS,
  FILTER_NAME_POST_TYPE,
  POST_TYPE_FILTER_MAPPING,
  FILTER_NAME_POST_ASSESSMENT_TYPE,
  FILTER_NAME_SUBJECTS,
  FILTER_NAME_CONTENT_TYPE,
  FILTER_NAME_COURSES,
  FILTER_NAME_WORKSHEET_FILTERS,
} from "Course/Constants/StringConstants";
import {
  TASK_TYPE_AI_TUTOR,
  ASSESSMENT_TYPE_AI_TUTOR,
  ASSESSMENT_TYPE_WORKSHEET,
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  TASK_TYPE_WORKSHEET,
} from "Constants/stringConstants";
import classNames from "classnames";
import {
  getOrganizationResourcesFeedQueryV2,
  getChildResourcesFeedQueryV2,
  getLELibraryFeedQuery,
} from "./modules/LeFeedQuery";
import {
  getOrganizationResourcesV2FromCache,
  getChildResourcesFromCacheV2,
  getLELibraryFeedFromCache,
  getLEFilters,
} from "./modules/LeFeedModule";
import update from "immutability-helper";

import {
  Checkbox,
  ChecklistDropdown,
  FilterLabelButton,
  Dropdown,
  DropdownMenu,
  ButtonDisclosure,
  SearchInput,
  Tag,
  Button,
  Avatar,
  Tooltip,
  useDSContext,
} from "@toddle-edu/ds-web";
import {
  FolderColored,
  EyeOutlined,
  EyeHiddenOutlined,
  NoteColored,
  LinkColored,
  TickCircleFilled,
  CircleOutlined,
} from "@toddle-edu/ds-icons";
import { getScoreDetailsMemoize } from "ScoreCategories/modules/ScoreCategoriesModule";
import { ASSESSMENT_TOOLS_OBJ } from "@toddle-edu/common-utils";
import ACLStore from "lib/aclStore";
import {
  ENABLE_ASSESSMENTS_IN_PYP,
  ENABLE_GLOBAL_HEADER_ON_MULTIPLE_SCREENS,
} from "Constants/permissionConstants";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { getLibraryCommonFeedFromCache } from "ToddleLibrary/modules/ToddleLibraryGraphqlHelpers";
import { getLibraryCommonFeedQuery } from "ToddleLibrary/modules/ToddleLibraryQuery";
import {
  getSubjectOptionsFromGradeId,
  getToddleLibraryEntityTypeFilter,
  getContextCurriculumProgramId,
  isMYPWorksheetEnabledForLibrary,
  getIsMYPGrade,
} from "ToddleLibrary/modules/ToddleLibraryUtils";
import {
  ENTITY_TYPE_LEARNING_EXPERIENCE,
  ENTITY_TYPE_WORKSHEET,
  WORKSHEET_ASSESSMENT,
  ASSESSMENT,
} from "ToddleLibrary/modules/Constants";
import {
  getWorksheetQuestionsCount,
  libraryCardKeys,
} from "Worksheet/modules/WorksheetUtils";
import { getIsWorksheetsEnabled } from "Worksheet/modules/WorksheetFeatureFlags";
import { GRADE_11_and_12 } from "Worksheet/modules/WorksheetConstants";
import HtmlParser from "react-html-parser";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { getIsCourseBasedGradingEnabled } from "LearningCourses/modules/Utils";
import { getIsAssessmentTypeConfigurationEnabled } from "Utils/ACLStoreUtils";
import { getDynamicAssessmentTypeOptions } from "Course/routes/ClassRoom/modules/utils";
import SkeletonLoader from "UIComponents/SkeletonLoader";

const noOfFiltersOutOfMore = 1;
const getSortedOptions = getMemoizedFunction(({ filterOptions }) => {
  return _.sortBy(filterOptions, "isArchived");
});

const getAbbreviationFromLocale = ({
  assessmentType,
  taskTypeGroup,
  localeLabel,
}) => {
  const assessmentTypeCheck = taskTypeGroup ? taskTypeGroup : assessmentType;
  if (
    assessmentTypeCheck === ASSESSMENT_TYPE_AI_TUTOR ||
    assessmentTypeCheck === TASK_TYPE_AI_TUTOR
  )
    return "AI";
  if (
    assessmentTypeCheck === ASSESSMENT_TYPE_WORKSHEET ||
    assessmentTypeCheck === TASK_TYPE_WORKSHEET
  )
    return "WS";

  const words = _.split(localeLabel, " ");
  return _.join(
    _.map(words, word => _.toUpper(_.head(word))),
    ""
  );
};

const getFilterDropdown = ({
  filter,
  onChangeFilterValues,
  filterValues,
  t,
  groupType,
  testId,
  styles = {},
}) => {
  const onFilterChange = params => {
    onChangeFilterValues({ ...filterValues, ...params }, Object.keys(params));
  };

  const filterId = _.get(filter, "id");

  const handleFilterSelection = e => {
    const selectedKey = e?.key;

    onFilterChange({
      [`${filterId}`]: selectedKey,
    });
  };

  const filterOptions = _.get(filter, "options", []);
  const showArchivedOptionsAtLast = _.get(
    filter,
    "showArchivedOptionsAtLast",
    false
  );

  const sortedOptions = showArchivedOptionsAtLast
    ? getSortedOptions({
        filterOptions,
      })
    : filterOptions;

  const filterLabel = _.get(filter, "label", "");
  const selectedOptions = _.get(filterValues, `${filterId}`, []);

  const labelButtonType = _.get(filter, "labelButtonType", "BUTTON_DISCLOSURE");
  const labelStyle = _.get(filter, "labelStyle", {});
  const variant = _.get(filter, "variant", "outlined-subtle");

  const updatedOptions = _.map(
    sortedOptions,
    ({ label, value, isArchived }) => {
      return {
        key: value,
        label,
        value,
        isArchived,
      };
    }
  );

  const labelButton = () => {
    if (_.isEqual(labelButtonType, "FILTER_LABEL")) {
      let labelValue = "All";

      if (!_.isEmpty(selectedOptions)) {
        const selectedOptionObj = _.find(
          updatedOptions,
          opt => opt?.key === selectedOptions
        );
        labelValue = _.get(selectedOptionObj, "label", "All");
      }

      return (
        <FilterLabelButton
          type="plain"
          variant="neutral"
          _legacy_variant="plain"
          label={t(filterLabel)}
          labelValue={labelValue}
          labelStyle={labelStyle}
          testId={`${testId}-leFeed-filter-${filterId}`}
        />
      );
    } else {
      const selectedLabel = _.get(
        _.find(
          updatedOptions,
          option => _.get(option, "value") == selectedOptions
        ),
        "label",
        ""
      );

      return (
        <ButtonDisclosure
          type="outlined"
          variant="neutral"
          _legacy_variant={variant}
          size="medium"
          testId={`${testId}-leFeed-filter-${filterId}`}
        >
          {selectedLabel}
        </ButtonDisclosure>
      );
    }
  };

  return (
    <LinkWithTooltip
      isVisible={!!filter.isToolTipVisible}
      tooltip={filter.toolTipText}
      key={filter.id}
    >
      {_.get(filter, "isCheckList") ? (
        <ChecklistDropdown
          options={updatedOptions}
          value={selectedOptions}
          onChange={value => {
            onFilterChange({
              [`${filterId}`]: value,
            });
          }}
          showAllOption={filter.showAllOption}
          isSearchEnabled={filter.showSearchBar || filter.isSearchBasedOnQuery}
          showSelectedOptionsOnTop={filter.showSelectedOptionsOnTop}
          testId={`${testId}-leFeed-filter-${filterId}`}
          onScrollEnd={filter.onScrollEnd}
          loader={
            filter.isLoadingMoreOptions ? (
              <div className={classes.skeleton}>
                <SkeletonLoader width="100%" height={16} />
                <SkeletonLoader width="100%" height={16} />
              </div>
            ) : null
          }
        >
          <FilterLabelButton
            size="medium"
            type="plain"
            variant="neutral"
            _legacy_variant="plain"
            label={t(filterLabel)}
            labelValue={getLabelValueForMultiFilterLabelButton({
              options: updatedOptions,
              selectedOptions: _.map(selectedOptions, option => {
                const selectedOptionObj = _.find(
                  updatedOptions,
                  opt => opt?.key === option
                );
                return _.get(selectedOptionObj, "label");
              }),
              t,
            })}
            testId={`${testId}-leFeed-filter-${filterId}`}
          />
        </ChecklistDropdown>
      ) : (
        <Dropdown
          overlay={
            <DropdownMenu
              options={updatedOptions}
              onClick={handleFilterSelection}
              showSelection
              value={_.get(filterValues, filter?.id)}
              itemTitleContainerStyle={styles.dropdownStyle}
              testId={`${testId}-leFeed-filter-${filterId}`}
            />
          }
        >
          {labelButton()}
        </Dropdown>
      )}
    </LinkWithTooltip>
  );
};

const getAssessments = ({ data }) => {
  if (!data) {
    return [];
  }
  return _.map(data, item => {
    return { ...item.node, resourceType: "ASSESSMENT" };
  });
};

const getResources = ({ items }) => {
  if (!items) {
    return [];
  }
  return _.map(items, item => {
    return { ...item, resourceType: "ORGANIZATION_RESOURCE" };
  });
};

const getDropdownFilters = (
  activeTab,
  isAssessmentTypeConfigEnabled = false
) => {
  if (_.isEqual(activeTab, "all") || _.isEqual(activeTab, "resources")) {
    return {
      groupType: undefined,
      assessmentTypes: undefined,
      taskTypeIds: undefined,
    };
  }

  // When FF is on, activeTab will be the taskTypeId
  if (isAssessmentTypeConfigEnabled) {
    return {
      groupType: undefined,
      taskTypeIds: [activeTab],
      assessmentTypes: undefined,
    };
  }
  return {
    groupType:
      activeTab === "worksheet"
        ? "WORKSHEET"
        : activeTab === "le"
        ? "LEARNING_ENGAGEMENT"
        : "ASSESSMENT",
    assessmentTypes: activeTab !== "assessment" ? activeTab : undefined,
  };
};

const getTabs = ({
  t,
  feedAsPosts,
  curriculumType,
  groupType,
  importFromToddleLibrary,
  globalGradeUid,
  endpoint,
  showResources,
  curriculumProgramId: curriculumId,
}) => {
  const isAssessmentTypeConfigEnabled = getIsAssessmentTypeConfigurationEnabled();

  const filters = [];

  // Always include "All" filter
  filters.push({
    label: t("common:all"),
    key: "all",
    curriculumTypes: [
      CURRICULUM_TYPE_DP,
      CURRICULUM_TYPE_MYP,
      CURRICULUM_TYPE_UBD,
      CURRICULUM_TYPE_PYP,
    ],
    type: "ALL",
  });

  if (isAssessmentTypeConfigEnabled && curriculumId) {
    // Get dynamic assessment type options from cache
    const taskTypes = getDynamicAssessmentTypeOptions({ curriculumId });

    // Add dynamic assessment filters (excluding AI_TUTOR)
    _.forEach(taskTypes, taskType => {
      const taskTypeValue = _.get(taskType, "taskType", "");
      const taskTypeLabel = _.get(taskType, "label", "");
      const taskTypeId = _.get(taskType, "taskTypeId", "");

      // Filter out AI_TUTOR type
      if (taskTypeValue === "AI_TUTOR") {
        return;
      }

      // For ASSESSMENT type, add to specific curriculums
      if (taskTypeValue === "ASSESSMENT") {
        filters.push({
          label: taskTypeLabel,
          key: taskTypeId,
          type: "ASSESSMENT",
          curriculumTypes: [
            CURRICULUM_TYPE_DP,
            CURRICULUM_TYPE_MYP,
            CURRICULUM_TYPE_UBD,
          ],
          taskTypeId,
        });
      } else if (
        taskTypeValue === TASK_TYPE_WORKSHEET &&
        ACLStore.can("FeatureFlag:LeFeedWorksheet")
      ) {
        // For worksheet type
        filters.push({
          label: taskTypeLabel,
          key: taskTypeId,
          type: TASK_TYPE_WORKSHEET,
          curriculumTypes: [
            CURRICULUM_TYPE_DP,
            CURRICULUM_TYPE_MYP,
            CURRICULUM_TYPE_PYP,
          ],
          taskTypeId,
        });
      } else {
        // For other types
        filters.push({
          label: taskTypeLabel,
          key: taskTypeId,
          type: taskTypeValue,
          curriculumTypes: [
            CURRICULUM_TYPE_DP,
            CURRICULUM_TYPE_MYP,
            CURRICULUM_TYPE_UBD,
            CURRICULUM_TYPE_PYP,
          ],
          taskTypeId,
        });
      }
    });
  } else {
    // When FF is off, use existing static filters
    filters.push(
      {
        label: t("common:le_label"),
        key: "le",
        type: "LEARNING_ENGAGEMENT",
        curriculumTypes: [
          CURRICULUM_TYPE_DP,
          CURRICULUM_TYPE_MYP,
          CURRICULUM_TYPE_UBD,
          CURRICULUM_TYPE_PYP,
        ],
      },
      {
        label: t("classRoom:formative_assessment"),
        key: "fmt",
        type: "ASSESSMENT",
        curriculumTypes: [CURRICULUM_TYPE_DP, CURRICULUM_TYPE_MYP],
      },
      {
        label: t("classRoom:summative_assessment"),
        key: "smt",
        type: "ASSESSMENT",
        curriculumTypes: [CURRICULUM_TYPE_DP, CURRICULUM_TYPE_MYP],
      },
      {
        label: t("common:assessment"),
        key: "assessment",
        type: "ASSESSMENT",
        curriculumTypes: [CURRICULUM_TYPE_UBD],
      }
    );

    if (ACLStore.can("FeatureFlag:LeFeedWorksheet")) {
      filters.push({
        label: t("common:worksheet"),
        key: "worksheet",
        type: "WORKSHEET",
        curriculumTypes: [
          CURRICULUM_TYPE_DP,
          CURRICULUM_TYPE_MYP,
          CURRICULUM_TYPE_PYP,
        ],
      });
    }
  }

  // Add resources filter if enabled
  if (showResources) {
    filters.push({
      label: t("common:resources"),
      key: "resources",
      type: "ORGANIZATION_RESOURCE",
      curriculumTypes: [
        CURRICULUM_TYPE_DP,
        CURRICULUM_TYPE_MYP,
        CURRICULUM_TYPE_UBD,
        CURRICULUM_TYPE_PYP,
      ],
    });
  }

  // Handle ENABLE_ASSESSMENTS_IN_PYP permission
  if (ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP)) {
    _.forEach(filters, filter => {
      if (filter.type === "ASSESSMENT") {
        // Only for FF off case
        if (
          _.includes(["fmt", "smt"], filter.key) ||
          isAssessmentTypeConfigEnabled
        ) {
          filter.curriculumTypes.push(CURRICULUM_TYPE_PYP);
        }
      }
    });
  }

  if (feedAsPosts) {
    return _.filter(filters, filter => {
      if (groupType) {
        return (
          (_.isEqual(filter.type, groupType) ||
            _.isEqual(filter.type, "ALL")) &&
          _.includes(filter.curriculumTypes, curriculumType)
        );
      } else {
        return _.includes(filter.curriculumTypes, curriculumType);
      }
    });
  } else if (importFromToddleLibrary) {
    return getToddleLibraryEntityTypeFilter({
      t,
      curriculumType,
      globalGradeUid,
      endpoint,
    });
  } else {
    return [
      {
        label: t("common:all_label", { label: t("common:le_label_plural") }),
        key: `ALL`,
      },
      { label: t("common:my_bookmarks"), key: `SAVED` },
    ];
  }
};

const getTabsMemoize = _.memoize(
  params => getTabs(params),
  params => JSON.stringify(params)
);
const containerStyle = {
  background: `#f3fafb`,
  border: `1px solid ${colors.blue400}`,
};

/**
 * Toggle selection for an item in the feed.
 * - In multi-select mode: Adds the item to selectedItems if not present, otherwise removes it.
 * - In single-select mode: not used, since toggleItemSelected is used only on checkbox click.
 */
const toggleItemSelected = ({
  id,
  selectedItems,
  updateSelectedItems,
  resourceType,
  showResources,
  key,
}) => {
  const index = showResources
    ? _.findIndex(selectedItems, item => _.isEqual(item.key, key))
    : _.indexOf(selectedItems, id);
  let selectedItemsLocal = [];
  if (index < 0) {
    selectedItemsLocal = update(selectedItems, {
      $push: showResources ? [{ id, resourceType, key }] : [id],
    });
  } else {
    selectedItemsLocal = update(selectedItems, { $splice: [[index, 1]] });
  }
  updateSelectedItems(selectedItemsLocal);
};

/**
 * Handle click on a feed item - updates assessmentId on clicking LE item
 * - In multi-select mode: used to display the item in right pane.
 * - In single-select mode: the selected assessment is the one being imported.
 */
const clickedLeItem = ({
  id,
  updateAssessmentId,
  isMultiSelect,
  isEyePreviewEnabled,
}) => {
  if (isMultiSelect) {
    if (!isEyePreviewEnabled) {
      updateAssessmentId(id);
    }
  } else {
    updateAssessmentId(id);
  }
};

const handleScroll = ({ hasNextPage, networkStatus, loadMore, scrollRef }) => {
  if (scrollRef) {
    if (
      hasNextPage &&
      networkStatus != 3 &&
      checkScrollAtBottom(scrollRef.current)
    ) {
      loadMore();
    }
  }
};

const getCountHeadingComponent = ({
  feedAsPosts,
  importFromLeLibrary,
  activeTab,
  count,
  titleTextStyle,
  t,
  curriculumType,
  isMultiSelect = false,
  selectedItemsCount = 0,
}) => {
  const canAddMYPWorksheet =
    _.isEqual(curriculumType, CURRICULUM_TYPE_MYP) &&
    isMYPWorksheetEnabledForLibrary() &&
    getIsWorksheetsEnabled() &&
    !importFromLeLibrary;

  const selectedCountHeading =
    selectedItemsCount > 1
      ? t("common:itemSelected_lable_plural", {
          count: `${selectedItemsCount}/${count}`,
        })
      : t("common:itemSelected_lable", {
          count: `${selectedItemsCount}/${count}`,
        });

  return (
    <div
      className={classNames(classes.titleText, "text-label-1")}
      style={titleTextStyle}
    >
      {isMultiSelect && selectedItemsCount > 0
        ? selectedCountHeading
        : t(
            feedAsPosts || importFromLeLibrary || canAddMYPWorksheet
              ? "common:post_label"
              : activeTab == "worksheet"
              ? "toddleLibrary:worksheets_with_count"
              : "common:le_with_count",
            {
              count,
            }
          )}
    </div>
  );
};

const CardWithProfilePicture = props => {
  const {
    feedItemTitleStyle,
    title,
    id,
    showCardWithStaffProfile,
    importFromLeLibrary,
    gradeNames,
    duration,
    assessmentTools,
    imageUrl,
    staffNameStyle,
    staffDetailsStyle,
    profileImageContainerProps,
    name,
    t,
    label,
    testId,
    avatarName,
    localeLabel,
  } = props;

  const assessmentToolsLabels = _.map(assessmentTools, assessmentTool => {
    return t(_.get(ASSESSMENT_TOOLS_OBJ, `${assessmentTool}.locale`));
  });

  return (
    <React.Fragment>
      <div className={classes.feedItemTitleText} style={feedItemTitleStyle}>
        {!_.isEmpty(title) ? title : t("common:untitled")}
      </div>
      <div className={classes.durationAndTool}>
        {showCardWithStaffProfile || importFromLeLibrary ? (
          <MoreItemWithToolTip
            testId={`${testId}-leFeedCard-${id}`}
            items={gradeNames}
            length={2}
            tabIndex={-1}
            noItemText={" "}
            moreStyle={{ color: colors.blue400, paddingLeft: "0px" }}
          />
        ) : (
          duration
        )}
        {!_.isEmpty(label) ? (
          <span className={classes.dotContainer}>
            <span className={classes.dot}></span>
          </span>
        ) : null}
        {!_.isEmpty(label) ? (
          <Tooltip tooltip={localeLabel} placement="top" visible={true}>
            <span>{label}</span>
          </Tooltip>
        ) : null}
        {(((showCardWithStaffProfile || importFromLeLibrary) &&
          !_.isEmpty(gradeNames)) ||
          duration) &&
          !_.isEmpty(assessmentToolsLabels) && (
            <span className={classes.dotContainer}>
              <span className={classes.dot}></span>
            </span>
          )}
        {!_.isEmpty(assessmentTools) && (
          <MoreItemWithToolTip
            testId={`${testId}-leFeedCard-${id}`}
            items={assessmentToolsLabels}
            length={1}
            noItemText={" "}
            tabIndex={-1}
            moreStyle={{ color: colors.blue400, paddingLeft: "0px" }}
          />
        )}
      </div>
      <div className={classes.staffDetails} style={staffDetailsStyle}>
        <Avatar
          className={classes.profileImageContainer}
          name={avatarName || name}
          size={"small"}
          color={"neutral"}
          src={imageUrl}
          {...profileImageContainerProps}
        />
        <div className={classes.staffNameWithUserPic} style={staffNameStyle}>
          {name}
        </div>
      </div>
    </React.Fragment>
  );
};

const ResourceCardWithProfilePicture = props => {
  const {
    feedItemTitleStyle,
    title,
    imageUrl,
    staffNameStyle,
    name,
    t,
    attachmentType,
  } = props;

  return (
    <React.Fragment>
      <div className={classes.feedItemTitleText} style={feedItemTitleStyle}>
        {!_.isEmpty(title)
          ? HtmlParser(getStyleStrippedText({ text: title }))
          : t("common:untitled")}
      </div>
      <div className={classes.durationAndTool}>
        {!_.isEmpty(attachmentType) ? <span>{attachmentType}</span> : null}
      </div>
      <div className={classes.staffDetails}>
        <Avatar
          className={classes.profileImageContainer}
          name={name}
          size={"small"}
          color={"neutral"}
          src={imageUrl}
        />
        <div className={classes.staffNameWithUserPic} style={staffNameStyle}>
          {name}
        </div>
      </div>
    </React.Fragment>
  );
};

const CardWithoutProfilePicture = props => {
  const {
    typeObj,
    label,
    index,
    feedAsPosts,
    title,
    assessmentTools,
    duration,
    name,
    t,
    testId,
    id,
  } = props;
  return (
    <React.Fragment>
      <div
        className={classes.assessmentTypeLabel}
        style={{ color: `${typeObj.color}` }}
      >
        {`${index + 1}# ${label ? label : ""}`}
      </div>
      <div
        className={
          feedAsPosts ? classes.postItemTitleText : classes.feedItemTitleText
        }
      >
        {!_.isEmpty(title) ? title : t("common:untitled")}
      </div>
      <div className={classes.durationAndTool}>
        {duration && !_.isEmpty(assessmentTools?.edges) ? (
          <React.Fragment>
            {duration}
            <div className={classes.dotContainer}>
              <div className={classes.dot} />
            </div>
            <MoreItemWithToolTip
              testId={`${testId}-leFeedCard-${id}-assessmentTools`}
              items={assessmentTools}
              length={1}
              tabIndex={-1}
              noItemText={" "}
            />
          </React.Fragment>
        ) : !_.isEmpty(duration) ? (
          duration
        ) : (
          !_.isEmpty(assessmentTools?.edges) && (
            <MoreItemWithToolTip
              testId={`${testId}-leFeedCard-${id}-assessmentTools`}
              items={assessmentTools}
              length={1}
              tabIndex={-1}
              noItemText={" "}
            />
          )
        )}
      </div>
      <div
        className={
          feedAsPosts ? classes.staffDetailsPostFeed : classes.staffDetails
        }
      >
        <div className={classes.staffName}>
          {t("common:by_with_label", {
            label: name,
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

const CardWithGradesAndSubjects = props => {
  const {
    title,
    testId,
    feedItemTitleStyle,
    gradeNames,
    subjectNames,
    t,
    id,
  } = props;
  return (
    <React.Fragment>
      <div className={classes.feedItemTitleText} style={feedItemTitleStyle}>
        {!_.isEmpty(title) ? title : t("common:untitled")}
      </div>
      <div
        className={classNames(classes.gradeAndSubjectContainer, "text-body-2")}
      >
        <MoreItemWithToolTip
          testId={`${testId}-leFeedCard-${id}-grades`}
          items={gradeNames}
          length={1}
          tabIndex={-1}
          noItemText={" "}
        />
        {!_.isEmpty(gradeNames) && !_.isEmpty(subjectNames) ? (
          <span className={classes.dotContainer}>
            <span className={classes.bigDot}></span>
          </span>
        ) : null}
        <MoreItemWithToolTip
          testId={`${testId}-leFeedCard-${id}-subjects`}
          items={subjectNames}
          length={2}
          noItemText={" "}
          tabIndex={-1}
        />
      </div>
    </React.Fragment>
  );
};

const CardWithMarksQuestionsAndSubjects = props => {
  const {
    title,
    feedItemTitleStyle,
    maxScore,
    maxQuestions,
    subjectNames,
    t,
    keys,
    testId,
    id,
  } = props;
  const items = _.filter(
    [maxScore, maxQuestions, subjectNames],
    item => !_.isEmpty(item)
  );
  return (
    <React.Fragment>
      <div className={classes.feedItemTitleText} style={feedItemTitleStyle}>
        {!_.isEmpty(title) ? title : t("common:untitled")}
      </div>
      <div
        className={classNames(classes.gradeAndSubjectContainer, "text-body-2")}
      >
        {items.map((item, index) => {
          return (
            <div className="flex" key={keys[index]}>
              {index !== 0 ? (
                <span className={classes.dotContainer}>
                  <span className={classes.bigDot}></span>
                </span>
              ) : null}
              <MoreItemWithToolTip
                testId={`${testId}-leFeedCard-${id}-gradeAndSubjects`}
                items={item}
                length={1}
                tabIndex={-1}
                noItemText={" "}
              />
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

const getAttachmentIcon = ({ isIcon, mimeType, type }) => {
  if (type === "NOTE") return <NoteColored />;
  else if (type === "LINK") return <LinkColored />;
  else return isIcon ? getThumbnailIcon({ mimeType }) : null;
};

const getResourceTitle = ({ attachment }) => {
  if (_.get(attachment, "type", "") === "NOTE") {
    return htmlToText(_.get(attachment, "title", ""));
  }
  return _.get(attachment, "name", "") || _.get(attachment, "title", "");
};

const getItemData = ({ resourceType, listItem, t }) => {
  switch (resourceType) {
    case "ORGANIZATION_RESOURCE": {
      const attachment = _.get(listItem, "attachment", {});
      const title = getResourceTitle({ attachment });
      const { isIcon, thumbUrl } = getThumbUrl({ attachment });
      return {
        title,
        attachmentType: getMediaCardFileType({
          type: _.get(attachment, "type", ""),
          mimeType: _.get(attachment, "mimeType", ""),
        }),
        name: getFormattedUserName({ user: attachment?.createdBy }),
        itemImageURL: thumbUrl,
        profileImageUrl: _.get(attachment, "createdBy.profileImage", ""),
        icon: getAttachmentIcon({
          isIcon,
          mimeType: _.get(attachment, "mimeType", ""),
          type: _.get(attachment, "type", ""),
        }),
      };
    }
    case "ASSESSMENT": {
      const createdBy = _.get(listItem, "createdBy");
      const isStaffArchived = getUserArchivalStatus(createdBy);
      const formattedUserName = getFormattedUserName({
        user: listItem?.createdBy,
      });
      const formattedCreatedBy = getArchivedText({
        name: formattedUserName,
        isArchived: isStaffArchived,
        t,
      });
      return {
        title: _.get(listItem, "title.value", ""),
        assessmentType: _.get(listItem, "assessmentType.value", ""),
        taskTypeGroup: _.get(listItem, "taskType.type", ""),
        name: formattedCreatedBy,
        itemImageURL:
          _.get(listItem, "image.value", "") ||
          PLACEHOLDER_SQUARE_IMAGE[
            listItem?.id % PLACEHOLDER_SQUARE_IMAGE_COUNT
          ],
        profileImageUrl: _.get(listItem, "createdBy.profileImage", ""),
        icon: null,
        avatarName: formattedUserName,
      };
    }
    default:
      return {};
  }
};

const FeedListComp = ({
  activeTab,
  listItem,
  id,
  testId,
  isSelected,
  updateAssessmentId,
  setWorksheetItem,
  t,
  index,
  feedAsPosts,
  importFromLeLibrary,
  imageContainerStyle,
  customSelectedContainerStyle,
  customNonSelectedContainerStyle,
  currentlySelectedstyle,
  selectedItems,
  isMultiSelect,
  currentlySelected,
  updateSelectedItems,
  showCardWithStaffProfile,
  feedItemTitleStyle,
  staffProfileImageStyle,
  staffNameStyle,
  showCheckBox,
  updateCurrentUnitFlowSection,
  currentAssessmentTypes,
  assessmentId,
  isEyePreviewEnabled,
  importFromToddleLibrary,
  feedDataListContainerStyle,
  showResources,
  itemKey,
  feedListCompRefs,
  onKeyDown,
  staffDetailsStyle,
  profileImageContainerProps,
}) => {
  const resourceType = _.get(listItem, "resourceType") || "ASSESSMENT";
  const handleFolderClick = () => updateCurrentUnitFlowSection(id);
  const isFolder = _.isEqual(resourceType, "FOLDER");

  const getFeedDataListStyles = () => {
    let styles = {};
    if (isMultiSelect) {
      if (currentlySelected) {
        styles = {
          ...containerStyle,
          ...currentlySelectedstyle,
        };
      } else {
        styles = customNonSelectedContainerStyle;
      }
    } else {
      if (isSelected) {
        styles = {
          ...containerStyle,
          ...customSelectedContainerStyle,
        };
      } else {
        styles = customNonSelectedContainerStyle;
      }
    }
    return { ...styles, ...feedDataListContainerStyle };
  };

  if (isFolder) {
    const label = _.get(listItem, "label");
    return (
      <div
        className={classes.feedDataListContainer}
        key={id}
        onClick={handleFolderClick}
        data-test-id={`${testId}-leFeedCard-${id}`}
        style={getFeedDataListStyles()}
      >
        <div className={classes.feedDataInnerContainer}>
          <div
            className={classes.folderImageContainer}
            style={imageContainerStyle}
          >
            <FolderColored size={"small"} />
          </div>
          <div className={classes.feedItemTitleText} style={feedItemTitleStyle}>
            {!_.isEmpty(label) ? label : t("common:untitled")}
          </div>
        </div>
      </div>
    );
  }
  const {
    title,
    assessmentType,
    taskTypeGroup,
    name,
    profileImageUrl,
    itemImageURL,
    attachmentType,
    icon,
    avatarName,
  } = getItemData({ resourceType, listItem, t });
  const questionTypeWiseCount = _.get(
    listItem,
    "organizationResourcesV2.resourceTypeBasedCount.questionTypeWiseCount",
    []
  );
  const questionCount = getWorksheetQuestionsCount({
    data: questionTypeWiseCount,
  });

  const assessmentToolEdges = _.get(listItem, "assessmentTools.edges", []);
  const assessmentTools = _.map(assessmentToolEdges, ({ node }) => {
    return _.get(node, "assessmentToolType");
  });

  const { maxScore, isScoreEnabled } = getScoreDetailsMemoize({
    assessmentTools: _.get(listItem, "assessmentTools", []),
  });

  const totalQuestionsText = `${t("common:question_number", {
    count: questionCount,
  })}`;
  const totalMarks = parseInt(maxScore);
  const totalMarksText = `${t("common:mark_with_number", {
    count: totalMarks,
  })}`;
  const itemImageUrl = itemImageURL
    ? getRethumbUrl({
        width: 200,
        height: 200,
        imageUrl: itemImageURL,
        fitIn: true,
      })
    : "";
  const imageUrl = profileImageUrl
    ? getRethumbUrl({
        width: 50,
        height: 50,
        imageUrl: profileImageUrl,
        fitIn: true,
      })
    : "";
  const duration = convertDurationToString(
    _.get(listItem, "duration.value", "")
  );

  let gradeNames = _.map(_.get(listItem, "grades"), grade => grade.name);
  let subjectNames;

  if (importFromToddleLibrary) {
    const { libraryGrades = [], librarySubjects = [] } = listItem;
    gradeNames = _.map(libraryGrades, "label");
    subjectNames = _.map(librarySubjects, "label");
  }

  const typeObj = currentAssessmentTypes[assessmentType] || {};
  const localeLabel = typeObj?.localeLabel
    ? t(typeObj.localeLabel)
    : typeObj?.label;

  const assessmentAbbreviation = getAbbreviationFromLocale({
    assessmentType,
    localeLabel,
    taskTypeGroup,
  });

  const worksheetItem = {
    id,
    title,
    questionCount,
    totalMarks,
    imageUrl: itemImageUrl,
    questionTypeWiseCount,
  };

  const handleOnClickDataList = () => {
    clickedLeItem({
      id,
      updateAssessmentId,
      isMultiSelect,
      selectedItems,
      updateSelectedItems,
      isEyePreviewEnabled,
      resourceType,
      showResources,
      key: itemKey,
    });
    if (setWorksheetItem) {
      setWorksheetItem?.(worksheetItem);
    }
  };

  const handleToggleCheckbox = e => {
    e.stopPropagation();
    toggleItemSelected({
      id,
      selectedItems,
      updateSelectedItems,
      resourceType,
      showResources,
      key: itemKey,
    });
  };

  const toggleEyePreview = ({ e, id }) => {
    e.stopPropagation();
    updateAssessmentId(id);
    if (setWorksheetItem) {
      setWorksheetItem?.(worksheetItem);
    }
  };

  const cardWithoutProfilePictureComponent = (
    <CardWithoutProfilePicture
      typeObj={typeObj}
      testId={testId}
      label={localeLabel}
      index={index}
      feedAsPosts={feedAsPosts}
      title={title}
      assessmentTools={assessmentTools}
      duration={duration}
      name={name}
      t={t}
      id={id}
    />
  );

  const cardWithProfilePictureComponent = (
    <CardWithProfilePicture
      label={assessmentAbbreviation}
      localeLabel={localeLabel}
      feedItemTitleStyle={feedItemTitleStyle}
      title={title}
      testId={testId}
      id={id}
      showCardWithStaffProfile={showCardWithStaffProfile}
      importFromLeLibrary={importFromLeLibrary}
      gradeNames={gradeNames}
      duration={duration}
      assessmentTools={assessmentTools}
      imageUrl={imageUrl}
      staffProfileImageStyle={staffProfileImageStyle}
      staffNameStyle={staffNameStyle}
      name={name}
      t={t}
      isScoreEnabled={isScoreEnabled}
      maxScore={maxScore}
      importFromToddleLibrary={importFromToddleLibrary}
      avatarName={avatarName}
      staffDetailsStyle={staffDetailsStyle}
      profileImageContainerProps={profileImageContainerProps}
    />
  );
  const resourceCardWithProfilePictureComponent = (
    <ResourceCardWithProfilePicture
      attachmentType={attachmentType}
      feedItemTitleStyle={feedItemTitleStyle}
      title={title}
      imageUrl={imageUrl}
      staffProfileImageStyle={staffProfileImageStyle}
      staffNameStyle={staffNameStyle}
      name={name}
      t={t}
    />
  );

  const cardWithGradesAndSubjectsComponent = (
    <CardWithGradesAndSubjects
      title={title}
      feedItemTitleStyle={feedItemTitleStyle}
      gradeNames={gradeNames}
      subjectNames={subjectNames}
      t={t}
      id={id}
      testId={testId}
    />
  );

  const cardWithMarksQuestionsAndSubjectsComponent = (
    <CardWithMarksQuestionsAndSubjects
      title={title}
      feedItemTitleStyle={feedItemTitleStyle}
      subjectNames={subjectNames}
      maxScore={[totalMarksText]}
      maxQuestions={[totalQuestionsText]}
      t={t}
      keys={libraryCardKeys}
      id={id}
      testId={testId}
    />
  );

  const getLEDetails = () => {
    if (_.isEqual(resourceType, "ORGANIZATION_RESOURCE"))
      return resourceCardWithProfilePictureComponent;
    else if (feedAsPosts && !showCardWithStaffProfile) {
      return cardWithoutProfilePictureComponent;
    } else if (importFromToddleLibrary) {
      return activeTab === "worksheet"
        ? cardWithMarksQuestionsAndSubjectsComponent
        : cardWithGradesAndSubjectsComponent;
    } else {
      return cardWithProfilePictureComponent;
    }
  };

  const handleKeyDown = e => {
    if (e.key === "Enter" || e.key === " ") {
      e?.preventDefault();
      handleOnClickDataList();
    } else {
      onKeyDown?.(e);
    }
  };

  return (
    <div
      className={classes.feedDataListContainer}
      key={id}
      onClick={handleOnClickDataList}
      onKeyDown={handleKeyDown}
      style={getFeedDataListStyles()}
      ref={ref => {
        if (feedListCompRefs?.current) {
          feedListCompRefs.current[id] = ref;
        }
      }}
      tabIndex={index === 0 ? 0 : -1} // focus on 1st feed card on tab, then navigate using arrow keys
      data-test-id={`${testId}-leFeedCard-${id}`}
    >
      <div className={classes.imageContainerLe} style={imageContainerStyle}>
        <ResourceImagePlaceHolder
          id={id}
          type={resourceType}
          imageUrl={itemImageUrl}
          icon={icon}
          containerStyle={{ border: "none" }}
        />
      </div>
      <div className={classes.rightPane}>
        <div className={classes.leDetails}>{getLEDetails()}</div>

        <div className={classes.cardOptions}>
          {isEyePreviewEnabled &&
          !_.isEqual(resourceType, "ORGANIZATION_RESOURCE") ? (
            <div className={classes.eyePreview}>
              <div
                className={classes.eyePreviewIcon}
                onClick={e => toggleEyePreview({ e, id })}
                onKeyDown={e => {
                  onEnterOrSpaceKeyDown(e, () => {
                    toggleEyePreview({ e, id });
                  });
                }}
              >
                {_.isEqual(assessmentId, id) ? (
                  <Button
                    _legacy_variant="plain"
                    _legacy_size={"small"}
                    variant="neutral"
                    type={"plain"}
                    size={"medium"}
                    testId={`${testId}-leFeedCard-${id}-togglePreview`}
                    rightIcon={<EyeHiddenOutlined />}
                    style={{
                      padding: "4px",
                      paddingRight: "0px",
                      height: "20px",
                    }}
                  >
                    {t("classPlanner:preview_with_label", {
                      label: t("common:hide"),
                    })}
                  </Button>
                ) : (
                  <Button
                    _legacy_variant="plain"
                    _legacy_size={"small"}
                    variant="neutral"
                    type={"plain"}
                    testId={`${testId}-leFeedCard-${id}-togglePreview`}
                    size={"medium"}
                    rightIcon={<EyeOutlined />}
                    style={{
                      padding: "4px",
                      paddingRight: "0px",
                      height: "20px",
                    }}
                  >
                    {t("classPlanner:preview_with_label", {
                      label: t("common:show"),
                    })}
                  </Button>
                )}
              </div>
            </div>
          ) : null}

          {showCheckBox ? (
            isMultiSelect ? (
              <Checkbox
                testId={`${testId}-leFeedCard-${id}`}
                isChecked={isSelected}
                onClick={e => handleToggleCheckbox(e)}
              />
            ) : isSelected ? (
              <TickCircleFilled variant="link" size="xx-small" />
            ) : (
              <CircleOutlined variant="subtle" size="xx-small" />
            )
          ) : null}
        </div>
      </div>
    </div>
  );
};

const getNoDataComponentText = ({ curriculumType, t, activeTab }) => {
  if (activeTab == "worksheet") {
    return t("worksheet:worksheet_other");
  }
  // show empty text label as LE only for PYP if assessments are disabled
  if (!ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP) && curriculumType == "IB_PYP") {
    return t("common:le_label_plural");
  }

  return t("common:post_plural");
};
let LeFeedLocally = React.forwardRef(
  ({
    testId,
    activeTab,
    feedList,
    assessmentId,
    updateAssessmentId,
    hasNextPage,
    networkStatus,
    loadMore,
    t,
    totalCount,
    scrollRef,
    feedAsPosts,
    curriculumType,
    importFromLeLibrary,
    imageContainerStyle,
    customSelectedContainerStyle,
    customNonSelectedContainerStyle,
    feedContainerStyle,
    feedInnerContainerStyle,
    titleTextStyle,
    selectedItems = [],
    isMultiSelect,
    updateSelectedItems,
    currentlySelectedstyle,
    showCardWithStaffProfile,
    feedItemTitleStyle,
    staffProfileImageStyle,
    staffNameStyle,
    showCheckBox,
    updateCurrentUnitFlowSection,
    parentHierarchy,
    headerTabContainerStyle,
    currentFolder,
    customRef,
    getCurrentAssessmentTypes,
    isEyePreviewEnabled,
    importFromToddleLibrary,
    feedDataListContainerStyle,
    displayCountHeadingWithFilters,
    displayCountHeadingWithSearch,
    setTotalPostsCount,
    setWorksheetItem,
    showResources,
    staffDetailsStyle,
    profileImageContainerProps,
  }) => {
    const totalPosts = feedAsPosts ? feedList.length : totalCount;

    const feedListCompRefs = useRef({});
    const focusedElementIndexWithinFeedCard = useRef(-1);

    useEffect(() => {
      setTotalPostsCount(totalPosts);
    }, [totalPosts]);

    const isCurrentlySelected = ({ id, key }) => {
      let isSelected = false;
      if (isMultiSelect) {
        isSelected = showResources
          ? _.some(selectedItems, { key })
          : _.includes(selectedItems, id);
      } else {
        isSelected = assessmentId === id;
      }
      return isSelected;
    };

    const getId = ({ resourceType = "ASSESSMENT", feedData }) => {
      if (_.isEqual(resourceType, "ORGANIZATION_RESOURCE"))
        return _.get(feedData, "attachment.id", "");
      return feedAsPosts
        ? _.get(feedData, "id", "")
        : _.get(feedData, "node.id", "");
    };

    const onHierarchyClick = id => updateCurrentUnitFlowSection(id);

    const isInsideFolder = !_.isEmpty(parentHierarchy);
    const currentFolderLabel = isInsideFolder
      ? _.get(_.first(currentFolder), "label", "")
      : undefined;

    useImperativeHandle(
      customRef,
      () => ({
        currentFolderLabel,
      }),
      [currentFolderLabel]
    );

    /** If a card is active and has moreItem tooltip, then the focus should
     * go on that tooltip on Tab and then on Cancel button. In other cases, it should go on Cancel button on Tab
     */
    const moveFocusToNextOrPrevFeedData = (event, index) => {
      switch (event.key) {
        case "ArrowUp":
          {
            const newIndex = index === 0 ? 0 : index - 1;
            const id = getId({
              resourceType: _.get(feedList, `[${newIndex}].resourceType`),
              feedData: _.get(feedList, `[${newIndex}]`),
            });

            feedListCompRefs.current[id]?.focus();
            focusedElementIndexWithinFeedCard.current = -1;
            event.preventDefault();
          }
          break;
        case "ArrowDown":
          {
            const newIndex = index === _.size(feedList) - 1 ? index : index + 1;
            const id = getId({
              resourceType: _.get(feedList, `[${newIndex}].resourceType`),
              feedData: _.get(feedList, `[${newIndex}]`),
            });

            feedListCompRefs.current[id]?.focus();
            focusedElementIndexWithinFeedCard.current = -1;
            event.preventDefault();
          }
          break;
        case "Tab":
          {
            const id = getId({
              resourceType: _.get(feedList, `[${index}].resourceType`),
              feedData: _.get(feedList, `[${index}]`),
            });

            const currentFeedCard = feedListCompRefs.current[id];
            const focusedChildIndex = focusedElementIndexWithinFeedCard.current;

            /** Changed the tabIndex of focusable element(moreItemWithToolTip in this case)
             * to -1. So that the focus should only go on focusable elements of the active card
             */
            const focusableElements = getKeyboardFocusableElements(
              currentFeedCard
            );

            /** Handle shift+tab */
            if (event.shiftKey) {
              /** If the active element is the current feed card, then allow default behavior */
              const activeElement = document.activeElement;
              if (currentFeedCard === activeElement) {
                focusedElementIndexWithinFeedCard.current = -1;
                return;
              }

              /**
               * If the focused element is the first child, then focus on the current feed card
               * else focus on the previous child
               * */
              if (focusedChildIndex === 0) {
                currentFeedCard.focus();
              } else if (focusedChildIndex > 0) {
                focusableElements[focusedChildIndex - 1]?.focus();
              }

              focusedElementIndexWithinFeedCard.current = focusedChildIndex - 1;
            } else {
              /**
               * === Handle tab press ===
               * If the focused element is the last child, then allow default behavior
               * else focus on the next child
               * */
              if (
                _.isEmpty(focusableElements) ||
                focusedChildIndex === _.size(focusableElements) - 1
              ) {
                focusedElementIndexWithinFeedCard.current = -1;
                return;
              }

              focusableElements[focusedChildIndex + 1]?.focus();
              focusedElementIndexWithinFeedCard.current = focusedChildIndex + 1;
            }
            event.preventDefault();
          }
          break;
        default:
          break;
      }
    };

    return (
      <>
        {isInsideFolder ? (
          <div
            className={classes.breadCrumbsContainer}
            style={headerTabContainerStyle}
          >
            <BreadCrumbs
              hierarchy={parentHierarchy}
              onHierarchyClick={onHierarchyClick}
              postHierarchy={currentFolder}
            />
          </div>
        ) : null}
        <div
          className={classes.feedContainer}
          style={feedContainerStyle}
          ref={scrollRef}
          onScroll={() =>
            handleScroll({
              hasNextPage,
              networkStatus,
              loadMore,
              scrollRef,
            })
          }
        >
          <div
            className={classes.feedInnerContainer}
            style={feedInnerContainerStyle}
          >
            {totalPosts ? (
              <React.Fragment>
                {!displayCountHeadingWithFilters &&
                !displayCountHeadingWithSearch
                  ? getCountHeadingComponent({
                      feedAsPosts,
                      importFromLeLibrary,
                      count: totalPosts,
                      titleTextStyle,
                      t,
                      curriculumType,
                      isMultiSelect,
                      selectedItemsCount: selectedItems.length,
                    })
                  : null}
                {_.map(feedList, (feedData, index) => {
                  const { resourceType } = feedData;
                  const id = getId({ resourceType, feedData });
                  const key = _.get(feedData, "key", id);
                  const node = _.get(feedData, "node", []);
                  const isSelected = isCurrentlySelected({ id, key });
                  const currentlySelected = isEyePreviewEnabled
                    ? isSelected
                    : assessmentId === id;
                  return (
                    <FeedListComp
                      activeTab={activeTab}
                      listItem={feedAsPosts ? feedData : node}
                      key={key}
                      testId={testId}
                      itemKey={key}
                      id={id}
                      index={index}
                      feedAsPosts={feedAsPosts}
                      isSelected={isSelected}
                      updateAssessmentId={updateAssessmentId}
                      t={t}
                      importFromLeLibrary={importFromLeLibrary}
                      imageContainerStyle={imageContainerStyle}
                      customSelectedContainerStyle={
                        customSelectedContainerStyle
                      }
                      customNonSelectedContainerStyle={
                        customNonSelectedContainerStyle
                      }
                      currentlySelectedstyle={currentlySelectedstyle}
                      selectedItems={selectedItems}
                      isMultiSelect={isMultiSelect}
                      currentlySelected={currentlySelected}
                      updateSelectedItems={updateSelectedItems}
                      showCardWithStaffProfile={showCardWithStaffProfile}
                      feedItemTitleStyle={feedItemTitleStyle}
                      staffProfileImageStyle={staffProfileImageStyle}
                      staffNameStyle={staffNameStyle}
                      showCheckBox={showCheckBox}
                      updateCurrentUnitFlowSection={
                        updateCurrentUnitFlowSection
                      }
                      currentAssessmentTypes={getCurrentAssessmentTypes()}
                      assessmentId={assessmentId}
                      isEyePreviewEnabled={isEyePreviewEnabled}
                      importFromToddleLibrary={importFromToddleLibrary}
                      feedDataListContainerStyle={feedDataListContainerStyle}
                      setWorksheetItem={setWorksheetItem}
                      showResources={showResources}
                      feedListCompRefs={feedListCompRefs}
                      staffDetailsStyle={staffDetailsStyle}
                      profileImageContainerProps={profileImageContainerProps}
                      onKeyDown={e => moveFocusToNextOrPrevFeedData(e, index)} // for keyboard accessibility
                    />
                  );
                })}
                {networkStatus == 3 ? (
                  <div className={classes.loadingContainer}>
                    <Loading />
                  </div>
                ) : null}
              </React.Fragment>
            ) : (
              <NoDataComponent
                containerStyle={{ flex: 1, minHeight: "400px" }}
                emptyText={t("common:filter_result_msg", {
                  label: getNoDataComponentText({
                    t,
                    curriculumType,
                    feedAsPosts,
                    activeTab,
                  }),
                })}
                emptyHeaderText={""}
              />
            )}
          </div>
        </div>
      </>
    );
  }
);

LeFeedLocally.displayName = "LeFeedLocally";

const mapActionCreators = { getCurrentAssessmentTypes };

const mapStateToProps = (state, ownProps) => {
  const {
    activeTab,
    searchText,
    portalType,
    feedAsPosts,
    unitPlanId,
    leFeedFilters,
    shouldIncludeQuickTasks,
    showSearchChip,
    currentUnitFlowSection,
    parentResourceId,
    importFromToddleLibrary,
    allGrades,
    showResources,
    filtersInfo,
    defaultPostType,
    groupType,
    shouldShowWorksheet,
  } = ownProps;

  const curriculumType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const isAssessmentTypeConfigEnabled = getIsAssessmentTypeConfigurationEnabled();
  const dropdownFilters = getDropdownFilters(
    activeTab,
    isAssessmentTypeConfigEnabled
  );
  const assessmentTypes = dropdownFilters?.assessmentTypes;
  const taskTypeIds = dropdownFilters?.taskTypeIds;

  const showFlatten = !_.isEmpty(searchText) && !showSearchChip;

  const academicYearId = getSelectedAcademicYearId(state);
  const userArchivedFilters = {
    academicYearId,
  };

  const orgResourceId = showFlatten ? parentResourceId : currentUnitFlowSection;
  const organizationResourceFilters = {
    searchParentResourceId: orgResourceId,
    types: "PLANNER_FLOW_RESOURCE",
    resourceTypes: showResources
      ? [
          ...(!_.isEqual(activeTab, "resources") ? ["ASSESSMENT"] : []),
          "FOLDER",
          "ORGANIZATION_RESOURCE",
        ]
      : ["ASSESSMENT", "FOLDER"],
    assessmentTypes:
      !isAssessmentTypeConfigEnabled && !_.isEmpty(assessmentTypes)
        ? assessmentTypes
        : undefined,
    taskTypeIds:
      isAssessmentTypeConfigEnabled && !_.isEmpty(taskTypeIds)
        ? taskTypeIds
        : undefined,
    searchText: !_.isEmpty(searchText) ? searchText : "",
    searchParentResourceType: "FOLDER",
    isFlattenFeedStructure: showFlatten,
  };

  if (!feedAsPosts) {
    const userInfo = getUserInfo({ portalType });
    const orgId = userInfo.org_id;
    const curriculumProgramId = state.platform.currentCurriculumProgram.id;

    let toddleLibraryFeedQueryVariables = {};

    if (importFromToddleLibrary) {
      let grades = !_.isEmpty(leFeedFilters[FILTER_NAME_GRADES])
        ? [leFeedFilters[FILTER_NAME_GRADES]]
        : [];

      if (_.isEqual(activeTab, "worksheet") && _.isEmpty(grades)) {
        grades = _.get(_.find(allGrades, { label: GRADE_11_and_12 }), "id", []);
      }

      const subjects =
        !_.isEmpty(leFeedFilters[FILTER_NAME_SUBJECTS]) &&
        leFeedFilters[FILTER_NAME_SUBJECTS] != "all"
          ? [leFeedFilters[FILTER_NAME_SUBJECTS]]
          : [];

      // Set entityTypes based on grade selection - show worksheets for MYP grade, LEs for others
      const entityTypes = shouldShowWorksheet
        ? WORKSHEET_ASSESSMENT
        : activeTab == "learning_experience"
        ? ASSESSMENT
        : activeTab == "worksheet"
        ? WORKSHEET_ASSESSMENT
        : [];

      const worksheetFilters = leFeedFilters[FILTER_NAME_WORKSHEET_FILTERS];

      const feedType =
        leFeedFilters[FILTER_NAME_CONTENT_TYPE] == "ALL"
          ? undefined
          : leFeedFilters[FILTER_NAME_CONTENT_TYPE];

      toddleLibraryFeedQueryVariables = {
        id: userInfo.id,
        entityTypes,
        feedType,
        first: 10,
        seed: -0.47,
        searchText: !_.isEmpty(searchText) ? searchText : "",
        filters: {
          grades,
          subjects,
        },
        ...(!_.isEmpty(worksheetFilters) && {
          worksheetFilters,
        }),
        portalType,
        isPaginated: true,
        contextCurriculumProgramId: getContextCurriculumProgramId(state),
        showOnlyAccessible: true,
      };
    }

    const isAssessmentTypeConfigEnabled = getIsAssessmentTypeConfigurationEnabled();

    // function replaces the options that have all the options selected with [] and in case of assessment type filter it replaces the option with default values if "None" is selected
    const leFilters = getLEFilters({
      filters: leFeedFilters,
      options: filtersInfo,
      key: "id",
      defaultPostType,
    });

    // Get selected post types from filters
    const selectedPostTypes = _.get(leFilters, `${FILTER_NAME_POST_TYPE}`, []);

    let leLibraryFiltersFinal;

    if (isAssessmentTypeConfigEnabled) {
      // When FF is on, use taskTypeIds instead of types and assessmentTypes
      // Use _.omit to exclude types and assessmentTypes from leFilters before spreading
      const filteredLeFilters = _.omit(leFilters, [
        FILTER_NAME_POST_TYPE,
        FILTER_NAME_POST_ASSESSMENT_TYPE,
      ]);

      leLibraryFiltersFinal = {
        ...filteredLeFilters,
        // Send taskTypeIds directly (the values are already taskTypeIds from dynamic options)
        taskTypeIds: selectedPostTypes,
        curriculumProgramIds: [curriculumProgramId],
        isDeleted: false,
        isLeLibrary: true,
        shouldIncludeQuickTasks,
        searchText,
      };
    } else {
      leLibraryFiltersFinal = {
        ...leFilters,
        //uniq is used as some enum types as Assessment repeat
        [FILTER_NAME_POST_TYPE]: _.uniq(
          _.map(selectedPostTypes, item =>
            _.get(POST_TYPE_FILTER_MAPPING, `${item}.enumType`)
          )
        ),
        // Filter is required as post type filter in few curriculum Types are not using assessmentTypes
        [FILTER_NAME_POST_ASSESSMENT_TYPE]: _.filter(
          _.map(selectedPostTypes, item =>
            _.get(POST_TYPE_FILTER_MAPPING, `${item}.assessmentType`)
          )
        ),
        curriculumProgramIds: [curriculumProgramId],
        isDeleted: false,
        isLeLibrary: true,
        shouldIncludeQuickTasks,
        searchText,
      };
    }

    return {
      queryVariables: {
        id: userInfo.id,
        entityTypes: `ASSESSMENT`,
        feedType: activeTab == "ALL" ? undefined : activeTab,
        first: 9,
        searchText,
        portalType,
      },
      leLibraryFeedVariables: {
        id: orgId,
        filters: leLibraryFiltersFinal,
        userArchivedFilters,
      },
      toddleLibraryFeedQueryVariables,
      isData: true,
      isLoading: false,
    };
  }

  let queryFilter = {
    searchText: searchText || undefined,
    ...dropdownFilters,
  };

  // Remove undefined/null values from queryFilter based on FF state
  if (isAssessmentTypeConfigEnabled) {
    queryFilter = _.omit(queryFilter, ["assessmentTypes", "groupType"]);
  } else {
    queryFilter = _.omit(queryFilter, ["taskTypeIds"]);
  }

  if (groupType && !isAssessmentTypeConfigEnabled) {
    queryFilter.groupType =
      groupType === "WORKSHEET"
        ? groupType
        : ["LEARNING_ENGAGEMENT", "ASSESSMENT", "QUICK_TASK"];
  }

  return {
    queryVariables: {
      id: unitPlanId,
      portalType,
      filters: queryFilter,
    },
    isData: true,
    isLoading: false,
    curriculumType,
    organizationResourceFilters,
    orgResourceId,
  };
};

LeFeedLocally = compose(
  I18nHOC({ resource: ["common", "worksheet", "toddleLibrary"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getAssessmentOfUnitQuery, {
    name: "getAssessmentOfUnit",
    skip: ({ feedAsPosts, importFromLeLibrary, currentUnitFlowSection }) =>
      (!_.isUndefined(currentUnitFlowSection) &&
        !_.includes(["all_assessments", "all"], currentUnitFlowSection)) ||
      !feedAsPosts ||
      importFromLeLibrary,
    options: ({ queryVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: queryVariables,
    }),
    props({ getAssessmentOfUnit, ownProps: { unitPlanId } }) {
      const unitPlanDetails = _.get(
        getAssessmentOfUnit,
        "node.resourceLibrary",
        {}
      );
      return {
        feedList: getAssessments({
          data: _.get(unitPlanDetails, "edges", []),
        }),
        isData: !_.isEmpty(unitPlanDetails),
        networkStatus: getAssessmentOfUnit.networkStatus,
        isLoading:
          getAssessmentOfUnit["networkStatus"] == 1 ||
          getAssessmentOfUnit["networkStatus"] == 2,
      };
    },
  }),
  graphql(getOrganizationResourcesFeedQueryV2, {
    name: "getOrganizationResourcesFeedV2",
    skip: ({ feedAsPosts, importFromLeLibrary, currentUnitFlowSection }) =>
      !_.includes(["all_resources"], currentUnitFlowSection) ||
      !feedAsPosts ||
      importFromLeLibrary,
    options: ({ unitPlanId, searchText }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        parentId: unitPlanId,
        parentType: "UNIT_PLAN",
        searchText: searchText,
      },
    }),
    props({
      getOrganizationResourcesFeedV2,
      ownProps: { unitPlanId, searchText, isData, isLoading },
    }) {
      const organizationResourcesData = getOrganizationResourcesV2FromCache({
        parentId: unitPlanId,
        parentType: "UNIT_PLAN",
        searchText: searchText,
      });
      const organizationResources = _.get(
        organizationResourcesData,
        "node.organizationResourcesConnection"
      );
      const pageInfo = _.get(organizationResources, "pageInfo", {});
      const items = _.map(
        _.get(
          organizationResourcesData,
          "node.organizationResourcesConnection.edges",
          []
        ),
        "node"
      );
      const feedList = getResources({ items });
      return {
        isData: !_.isEmpty(organizationResourcesData) && isData,
        hasNextPage: pageInfo.hasNextPage,
        loadMore: prepareLoadMoreFeed({
          variables: {
            parentId: unitPlanId,
            parentType: "UNIT_PLAN",
            searchText,
            after: pageInfo.endCursor,
          },

          queryData: getOrganizationResourcesFeedV2,
          key: "organizationResourcesConnection",
        }),
        feedList,
        networkStatus: getOrganizationResourcesFeedV2.networkStatus,
        isLoading:
          getOrganizationResourcesFeedV2["networkStatus"] == 1 ||
          getOrganizationResourcesFeedV2["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getLELibraryFeedQuery, {
    name: "getLELibraryFeed",
    skip: ({ importFromLeLibrary }) => !importFromLeLibrary,
    options: ({ leLibraryFeedVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: leLibraryFeedVariables,
    }),
    props({
      getLELibraryFeed,
      ownProps: { leLibraryFeedVariables, isData, isLoading },
    }) {
      const data = getLELibraryFeedFromCache(leLibraryFeedVariables);

      const assessments = _.get(data, "node.assessments", {});
      const feedList = _.get(assessments, "edges", []);
      const pageInfo = _.get(assessments, "pageInfo", {});
      const totalCount = _.get(assessments, "totalCount", {});
      const endCursor = _.get(pageInfo, "endCursor", null);

      return {
        getLELibraryFeed,
        hasNextPage: _.get(pageInfo, "hasNextPage", false),
        feedList,
        totalCount,
        isData: !_.isEmpty(data) && isData,
        networkStatus: getLELibraryFeed.networkStatus,
        isLoading:
          getLELibraryFeed["networkStatus"] == 1 ||
          getLELibraryFeed["networkStatus"] == 2 ||
          isLoading,
        loadMore: prepareLoadMoreFeed({
          variables: {
            ...leLibraryFeedVariables,
            after: endCursor,
          },
          queryData: getLELibraryFeed,
          key: "assessments",
        }),
      };
    },
  }),
  graphql(getChildResourcesFeedQueryV2, {
    name: "getChildResourcesFeedV2",
    skip: ({ isUnitFlow, currentUnitFlowSection }) =>
      _.includes(
        ["all_assessments", "all_resources", "all"],
        currentUnitFlowSection
      ) || !isUnitFlow,
    options: ({ organizationResourceFilters, orgResourceId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: orgResourceId,
        filters: organizationResourceFilters,
        orderBy: "SEQUENCE",
        orderByDirection: "ASC",
      },
    }),
    props({
      getChildResourcesFeedV2,
      ownProps: {
        isData,
        isLoading,
        organizationResourceFilters,
        orgResourceId,
      },
    }) {
      const organizationResourcesData = getChildResourcesFromCacheV2({
        id: orgResourceId,
        filters: organizationResourceFilters,
        orderBy: "SEQUENCE",
        orderByDirection: "ASC",
      });

      const pageInfo = _.get(
        organizationResourcesData,
        "node.children.pageInfo"
      );
      const hasNextPage = _.get(pageInfo, "hasNextPage");
      const endCursor = _.get(pageInfo, "endCursor");

      const children = _.get(
        organizationResourcesData,
        "node.children.edges",
        []
      );

      const items = _.map(children, child => {
        const node = _.get(child, "node", {});
        const resourceType = _.get(node, "resourceType");
        switch (resourceType) {
          case "ASSESSMENT":
          case "ORGANIZATION_RESOURCE":
            return { ..._.get(node, "item", []), resourceType, key: node.id };
          case "FOLDER": {
            const { id, label, resourceType } = node;
            return {
              id,
              label,
              resourceType,
            };
          }
        }
      });

      const parentHierarchy = _.get(
        organizationResourcesData,
        "node.parentHierarchy",
        []
      );

      const currentFolder = [
        {
          id: _.get(organizationResourcesData, "node.id"),
          label: _.get(organizationResourcesData, "node.label"),
        },
      ];

      const networkStatus = _.get(getChildResourcesFeedV2, "networkStatus");

      return {
        isData: !_.isEmpty(organizationResourcesData) && isData,
        feedList: items,
        parentHierarchy,
        currentFolder,
        isLoading: _.includes([1, 2], networkStatus) || isLoading,
        hasNextPage,
        networkStatus,
        loadMore: prepareLoadMoreFeed({
          variables: {
            id: orgResourceId,
            filters: organizationResourceFilters,
            orderBy: "SEQUENCE",
            orderByDirection: "ASC",
            after: endCursor,
          },
          queryData: getChildResourcesFeedV2,
          key: "children",
        }),
      };
    },
  }),
  graphql(getLibraryCommonFeedQuery, {
    name: "getLibraryCommonFeed",
    skip: ({ importFromToddleLibrary, toddleLibraryFeedQueryVariables }) =>
      !importFromToddleLibrary ||
      _.isEmpty(toddleLibraryFeedQueryVariables?.filters?.grades),
    options: ({ toddleLibraryFeedQueryVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: toddleLibraryFeedQueryVariables,
    }),
    props({
      getLibraryCommonFeed,
      ownProps: { toddleLibraryFeedQueryVariables, isData, isLoading },
    }) {
      const data = getLibraryCommonFeedFromCache(
        toddleLibraryFeedQueryVariables
      );

      const entityObject = _.get(data, "node.libraryEntities", {});
      const feedList = _.get(entityObject, "edges", []);
      const totalCount = _.get(entityObject, "totalCount", {});

      const pageInfo = _.get(entityObject, "pageInfo", {});
      const endCursor = _.get(pageInfo, "endCursor", null);
      const hasNextPage = _.get(pageInfo, "hasNextPage", false);

      return {
        hasNextPage,
        feedList,
        totalCount,
        isData: !_.isEmpty(data) && isData,
        networkStatus: getLibraryCommonFeed.networkStatus,
        isLoading:
          [1, 2].includes(getLibraryCommonFeed["networkStatus"]) || isLoading,
        loadMore: prepareLoadMoreFeed({
          variables: {
            ...toddleLibraryFeedQueryVariables,
            after: endCursor,
          },
          queryData: getLibraryCommonFeed,
          customPathString: "node.libraryEntities",
        }),
      };
    },
  }),
  withLoader
)(LeFeedLocally);

const getSubjectFilterOptions = ({ grades, subjects }) => {
  return _.filter(
    subjects,
    subject => !_.isEmpty(_.intersection(grades, subject.grades))
  );
};

const LeFeed = React.memo(
  ({
    t,
    testId,
    assessmentId,
    setAssessmentId,
    unitPlanId,
    portalType,
    showHeaderText,
    feedConStyle,
    feedAsPosts,
    curriculumType,
    curriculumProgramId,
    importFromLeLibrary,
    defaultCourse,
    defaultAcademicYear,
    defaultGrades,
    defaultPostType,
    defaultCreators,
    curriculumProgramType,
    subjects,
    filtersInfo,
    showSubText = false,
    shouldIncludeQuickTasks,
    courseId,
    courseList,
    imageContainerStyle,
    customSearchBarStyle,
    customSelectedContainerStyle,
    customNonSelectedContainerStyle,
    feedContainerStyle,
    feedInnerContainerStyle,
    headerTabContainerStyle,
    moreFiltersBarStyle,
    titleTextStyle,
    selectedItems = [],
    isMultiSelect,
    isUnitFlow,
    currentUnitFlowSection,
    updateSelectedItems,
    currentlySelectedstyle,
    showCardWithStaffProfile,
    feedItemTitleStyle,
    staffProfileImageStyle,
    staffNameStyle,
    showCheckBox,
    updateCurrentUnitFlowSection,
    parentResourceId,
    groupType,
    headerContainerStyle,
    defaultSubject,
    isEyePreviewEnabled,
    importFromToddleLibrary,
    tabDropdownVariant = "plain",
    feedDataListContainerStyle,
    displayCountHeadingWithFilters,
    displayCountHeadingWithSearch,
    defaultContentType,
    activeEntityType,
    setActiveEntityType,
    setWorksheetItem,
    globalGradeUid,
    endpoint,
    allGrades,
    subjectsList,
    showResources = false,
    staffDetailsStyle,
    profileImageContainerProps,
  }) => {
    const tabValues = getTabsMemoize({
      t,
      feedAsPosts,
      curriculumType,
      groupType,
      importFromToddleLibrary,
      globalGradeUid,
      endpoint,
      showResources,
      curriculumProgramId,
    });
    const firstTab = _.get(tabValues[0], "key", undefined);
    const [activeTab, setActiveTab] = useState(activeEntityType || firstTab);
    const [searchText, updateSearchText] = useState("");
    const [leFeedFilters, updateLeFeedFilters] = useState({});
    const [selectedMoreOptions, setSelectedMoreOptions] = useState([]);
    const [currentFolderLabel, setCurrentFolderLabel] = useState("");
    const [showSearchChip, setShowSearchChip] = useState(true);
    const [totalPostsCount, setTotalPostsCount] = useState(0);
    const isCourseBasedGrading = getIsCourseBasedGradingEnabled();
    const customRef = useRef(null);
    const searchInputRef = useRef(null);

    // Get the selected grade data from the dropdown
    const selectedGradeData = useMemo(() => {
      const selectedGradeId = leFeedFilters[FILTER_NAME_GRADES];
      if (!selectedGradeId || !allGrades) return null;
      return _.find(allGrades, grade => _.get(grade, "id") === selectedGradeId);
    }, [leFeedFilters, allGrades]);

    // Calculate if worksheets should be shown in MYP context
    const shouldShowWorksheetInMyp =
      _.isEqual(curriculumType, CURRICULUM_TYPE_MYP) &&
      isMYPWorksheetEnabledForLibrary() &&
      getIsWorksheetsEnabled();

    const isMypGradeSelected = getIsMYPGrade({
      globalGradeUid: _.get(selectedGradeData, "label"),
    });

    const shouldShowWorksheet = shouldShowWorksheetInMyp && isMypGradeSelected;

    // Get the selected subject data from the dropdown
    const selectedSubjectData = useMemo(() => {
      const selectedSubjectId = leFeedFilters[FILTER_NAME_SUBJECTS];
      if (!selectedSubjectId || !subjectsList) return null;
      return _.find(
        subjectsList,
        subject => _.get(subject, "id") === selectedSubjectId
      );
    }, [leFeedFilters, subjectsList]);

    const customCallbackRef = useCallback(node => {
      if (node !== null) {
        customRef.current = node;
        setCurrentFolderLabel(customRef?.current?.currentFolderLabel);
      }
    }, []);

    useEffect(() => {
      if (!_.isEmpty(currentFolderLabel)) {
        setShowSearchChip(true);
      }
    }, [currentFolderLabel]);

    let defaultGrade = defaultGrades ? defaultGrades : [];

    const grade = _.get(
      _.find(courseList, course => course.courseId === courseId),
      "grade.id"
    );
    if (grade) {
      defaultGrade = [grade];
    }

    const isPYPCurriculum = _.isEqual(
      curriculumProgramType,
      CURRICULUM_TYPE_PYP
    );
    let updatedFiltersInfo = filtersInfo;
    if (importFromLeLibrary && !isPYPCurriculum) {
      updatedFiltersInfo = _.map(filtersInfo, filterInfo => {
        if (filterInfo.id === FILTER_NAME_SUBJECTS) {
          const isDisabled = _.isEmpty(leFeedFilters[FILTER_NAME_GRADES]);
          return {
            ...filterInfo,
            isDisabled,
            options: getSubjectFilterOptions({
              grades: leFeedFilters[FILTER_NAME_GRADES],
              subjects,
            }),
            isToolTipVisible: isDisabled,
          };
        }
        return filterInfo;
      });
    }

    if (importFromToddleLibrary) {
      updatedFiltersInfo = _.map(filtersInfo, filterInfo => {
        if (filterInfo.id === FILTER_NAME_SUBJECTS) {
          const isDisabled = _.isEmpty(leFeedFilters[FILTER_NAME_GRADES]);
          return {
            ...filterInfo,
            isDisabled,
            options: isDisabled
              ? []
              : getSubjectOptionsFromGradeId(
                  leFeedFilters[FILTER_NAME_GRADES],
                  "COMMUNITY"
                ),
            isToolTipVisible: isDisabled,
          };
        }
        return filterInfo;
      });
    }

    useEffect(() => {
      if (importFromLeLibrary) {
        onChangeLeFeedFilters({
          [FILTER_NAME_COURSES]: defaultCourse ? [defaultCourse] : [],
          [FILTER_NAME_ACADEMIC_YEAR]: [defaultAcademicYear],
          [FILTER_NAME_GRADES]: defaultGrade,
          [FILTER_NAME_CREATORS]: defaultCreators,
          [FILTER_NAME_POST_TYPE]: defaultPostType,
          [FILTER_NAME_SUBJECTS]: defaultSubject ? [defaultSubject] : [],
        });
        setSelectedMoreOptions(
          _.map(
            _.slice(
              updatedFiltersInfo,
              noOfFiltersOutOfMore,
              _.size(updatedFiltersInfo)
            ),
            item => item.id
          )
        );
      } else if (importFromToddleLibrary) {
        onChangeLeFeedFilters({
          [FILTER_NAME_GRADES]: defaultGrade,
          [FILTER_NAME_SUBJECTS]: defaultSubject,
          [FILTER_NAME_CONTENT_TYPE]: defaultContentType,
        });

        setSelectedMoreOptions(_.map(updatedFiltersInfo, "id"));
      }
    }, []);

    useEffect(() => {
      if (importFromToddleLibrary) {
        if (activeTab) {
          onChangeLeFeedFilters(
            {
              [FILTER_NAME_GRADES]: defaultGrade,
              [FILTER_NAME_SUBJECTS]: defaultSubject,
              [FILTER_NAME_CONTENT_TYPE]: defaultContentType,
            },
            [FILTER_NAME_GRADES]
          );

          setSelectedMoreOptions(_.map(updatedFiltersInfo, "id"));
        }
      }
    }, [activeTab, defaultGrade, importFromToddleLibrary]);

    const selectedMoreFilters = useMemo(() => {
      return _.filter(updatedFiltersInfo, filter => {
        const shouldIncludeSubjectFilter = isCourseBasedGrading
          ? filter.id !== FILTER_NAME_SUBJECTS
          : true;

        return (
          _.includes(selectedMoreOptions, filter.id) &&
          shouldIncludeSubjectFilter
        );
      });
    }, [selectedMoreOptions, updatedFiltersInfo]);

    const onChangeLeFeedFilters = (params, changedFilters) => {
      if (importFromToddleLibrary) {
        if (_.first(changedFilters) === FILTER_NAME_GRADES) {
          if (shouldShowWorksheetInMyp) {
            // Clear selected assessment and worksheet when grade changes
            const newGradeId = params[FILTER_NAME_GRADES];
            const currentGradeId = leFeedFilters[FILTER_NAME_GRADES];

            if (newGradeId === currentGradeId) return;

            // Check if switching between MYP and non-MYP grades
            const currentGrade = _.find(allGrades, { id: currentGradeId });
            const newGrade = _.find(allGrades, { id: newGradeId });

            const wasMyp = getIsMYPGrade({
              globalGradeUid: _.get(currentGrade, "label", ""),
            });
            const isMyp = getIsMYPGrade({
              globalGradeUid: _.get(newGrade, "label", ""),
            });

            if (wasMyp !== isMyp) {
              updateAssessmentId(null);
              setWorksheetItem?.(null);
            }

            setActiveEntityType?.(
              isMyp ? ENTITY_TYPE_WORKSHEET : ENTITY_TYPE_LEARNING_EXPERIENCE
            );
          }

          params = {
            ...params,
            [FILTER_NAME_SUBJECTS]: "",
          };
        }
      } else {
        if (
          !_.includes(
            [CURRICULUM_TYPE_PYP, CURRICULUM_TYPE_MYP, CURRICULUM_TYPE_DP],
            curriculumProgramType
          ) &&
          _.first(changedFilters) === FILTER_NAME_GRADES
        ) {
          //calculating subject list with changed grades
          const subjectOptions = getSubjectFilterOptions({
            grades: params[FILTER_NAME_GRADES],
            subjects,
          });

          //extracting values of subjects
          const subjectOptionsValues = _.map(
            subjectOptions,
            subject => subject.value
          );
          params = {
            ...params,
            //here we are only keeping those subjects in filters which are in the new calculated subject list
            [FILTER_NAME_SUBJECTS]: _.filter(
              leFeedFilters[FILTER_NAME_SUBJECTS],
              subject => _.includes(subjectOptionsValues, subject)
            ),
          };
        }
      }
      updateLeFeedFilters(prev => ({ ...prev, ...params }));
    };

    const resetDefaultGrade = () => {
      const worksheetDefaultGrade = _.get(
        _.find(allGrades, { label: GRADE_11_and_12 }),
        "id",
        defaultGrade
      );
      onChangeLeFeedFilters({ [FILTER_NAME_GRADES]: worksheetDefaultGrade }, [
        FILTER_NAME_GRADES,
      ]);

      if (importFromLeLibrary) {
        setSelectedMoreOptions(_.map(updatedFiltersInfo, "id"));
      }
    };

    const removeFilter = id => {
      onChangeLeFeedFilters({ [id]: [] });

      setSelectedMoreOptions(prev => {
        return _.filter(prev, option => !_.isEqual(option, id));
      });
    };

    const scrollRef = useRef(null);
    const resetScroll = () => {
      if (scrollRef && scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    };
    const onToggleTab = e => {
      const selectedTab = _.get(e, "key");
      setAssessmentId("");
      resetScroll();
      // To avoid fetching data for grades less than 11 in worksheet
      if (_.isEqual(selectedTab, "worksheet")) {
        resetDefaultGrade();
      }
      setActiveTab(selectedTab);
      setActiveEntityType?.(selectedTab);
    };

    const updateSearchTerm = value => {
      updateSearchText(value);
      resetScroll();
    };

    const updateAssessmentId = id => {
      setAssessmentId(id != assessmentId ? id : "");
    };

    const getHeaderTitle = () => {
      return importFromLeLibrary
        ? _.isEqual(curriculumType, CURRICULUM_TYPE_PYP)
          ? t("common:add_from_learning_experience_library")
          : t("common:add_from_learning_experience_&_assessment_library")
        : t("community:search_on_toddle_community");
    };

    const getSubTitle = () => {
      return t("common:import_from_le_modal_subtext", {
        label: _.isEqual(curriculumType, CURRICULUM_TYPE_PYP)
          ? _.capitalize(t("common:le_label"))
          : t("common:learning_experience_or_assessment"),
      });
    };

    const getRightContainer = () => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { dsVersion } = useDSContext();
      if (showResources && _.isEqual(parentResourceId, "all_resources"))
        return null;

      // Don't show right container if curriculum is MYP and worksheet is enabled
      if (
        _.isEqual(curriculumType, CURRICULUM_TYPE_MYP) &&
        isMYPWorksheetEnabledForLibrary() &&
        importFromToddleLibrary
      ) {
        return null;
      }

      const showDropdown =
        (!importFromToddleLibrary && !_.isEmpty(tabValues)) ||
        (importFromToddleLibrary && _.size(tabValues) > 1);

      if (groupType === "WORKSHEET") return null;

      const filteredInfo = isCourseBasedGrading
        ? _.filter(updatedFiltersInfo, item => item.name !== "subjects")
        : updatedFiltersInfo;

      return importFromLeLibrary ? (
        <MoreFilters
          testId={testId}
          filterValues={leFeedFilters}
          onChangeFilterValues={onChangeLeFeedFilters}
          getFilterDropdown={getFilterDropdown}
          selectedMoreOptions={selectedMoreOptions}
          setSelectedMoreOptions={setSelectedMoreOptions}
          filtersInfo={filteredInfo}
          noOfFiltersOutOfMore={noOfFiltersOutOfMore}
          t={t}
          groupType={groupType}
        />
      ) : showDropdown ? (
        <Dropdown
          overlay={
            <DropdownMenu
              testId={`${testId}-leFeed-filter`}
              options={tabValues}
              onClick={onToggleTab}
            />
          }
        >
          <ButtonDisclosure
            testId={`${testId}-leFeed-filter`}
            size={dsVersion === "2.0" ? "medium" : "large"}
            _legacy_variant={tabDropdownVariant}
            variant="neutral"
            type={"plain"}
          >
            {_.get(_.find(tabValues, { key: activeTab }), "label", "")}
          </ButtonDisclosure>
        </Dropdown>
      ) : null;
    };

    const leftPaneTitleClassList = classNames(classes.leftPaneTitleText, {
      [classes.leftPaneTitleTextWithSubtext]: showSubText,
    });

    const onCloseSearchChip = () => {
      searchInputRef?.current?.focus();
      setShowSearchChip(false);
    };

    const onFocusSearchInput = () => {
      const isInsideFolder = !_.isEmpty(currentFolderLabel);
      if (isInsideFolder && _.isEmpty(searchText)) {
        setShowSearchChip(true);
      }
    };

    const showMoreFilters = !_.isEmpty(selectedMoreFilters);

    const showChip = !_.isEmpty(currentFolderLabel) && showSearchChip;

    const getMoreFilters = () => {
      return (
        <MoreFiltersBar
          style={moreFiltersBarStyle}
          selectedMoreFilters={selectedMoreFilters}
          getFilterDropdown={getFilterDropdown}
          filterValues={leFeedFilters}
          onChangeFilterValues={onChangeLeFeedFilters}
          removeFilter={removeFilter}
          t={t}
          groupType={groupType}
          importFromToddleLibrary={importFromToddleLibrary}
          testId={testId}
          selectedGradeData={selectedGradeData}
          selectedSubjectData={selectedSubjectData}
          isWorksheetAssessment={shouldShowWorksheet}
        />
      );
    };
    const isGlobalHeaderOnMultipleScreensEnabled = ACLStore.can(
      ENABLE_GLOBAL_HEADER_ON_MULTIPLE_SCREENS
    );

    return (
      <div className={classes.container} style={feedConStyle}>
        <div className={classes.headerContainer} style={headerContainerStyle}>
          {showHeaderText && (
            <div className={leftPaneTitleClassList}>{getHeaderTitle()}</div>
          )}
          {showSubText && (
            <div className={classes.subTitle}>{getSubTitle()} </div>
          )}
          <div
            className={classes.headerTabContainer}
            style={headerTabContainerStyle}
          >
            <div
              className={classes.searchInputContainer}
              style={customSearchBarStyle}
            >
              <div className={classes.searchInput}>
                <SearchInput
                  value={searchText}
                  placeholder={t("common:search")}
                  onChange={updateSearchTerm}
                  onFocus={onFocusSearchInput}
                  ref={searchInputRef}
                  size="medium"
                  chip={
                    showChip ? (
                      <Tag
                        isClosable={true}
                        prefix={<FolderColored />}
                        onClose={onCloseSearchChip}
                      >
                        {currentFolderLabel}
                      </Tag>
                    ) : null
                  }
                  dsVersion={
                    isGlobalHeaderOnMultipleScreensEnabled ? "2.0" : "1.0"
                  }
                  focusSearchBySlash={isGlobalHeaderOnMultipleScreensEnabled}
                  testId={`${testId}-leFeed-searchBar`}
                />
              </div>
              {displayCountHeadingWithSearch
                ? getCountHeadingComponent({
                    feedAsPosts,
                    importFromLeLibrary,
                    activeTab,
                    count: totalPostsCount,
                    titleTextStyle,
                    t,
                    curriculumType,
                    isMultiSelect,
                    selectedItemsCount: selectedItems.length,
                  })
                : null}
            </div>
            {getRightContainer()}
          </div>
          {displayCountHeadingWithFilters ? (
            <div className={classes.countHeaderWithFiltersContainer}>
              {totalPostsCount
                ? getCountHeadingComponent({
                    feedAsPosts,
                    importFromLeLibrary,
                    activeTab,
                    count: totalPostsCount,
                    t,
                    curriculumType,
                    isMultiSelect,
                    selectedItemsCount: selectedItems.length,
                  })
                : null}
              {showMoreFilters && displayCountHeadingWithFilters ? (
                <div className={classes.filterContainer}>
                  {getMoreFilters()}
                </div>
              ) : null}
            </div>
          ) : null}
          {showMoreFilters && !displayCountHeadingWithFilters
            ? getMoreFilters()
            : null}
        </div>
        <LeFeedLocally
          testId={testId}
          assessmentId={assessmentId}
          activeTab={activeTab}
          updateAssessmentId={updateAssessmentId}
          searchText={searchText}
          leFeedFilters={leFeedFilters}
          portalType={portalType}
          unitPlanId={unitPlanId}
          scrollRef={scrollRef}
          feedAsPosts={feedAsPosts}
          importFromLeLibrary={importFromLeLibrary}
          curriculumType={curriculumType}
          shouldIncludeQuickTasks={shouldIncludeQuickTasks}
          imageContainerStyle={imageContainerStyle}
          customSelectedContainerStyle={customSelectedContainerStyle}
          customNonSelectedContainerStyle={customNonSelectedContainerStyle}
          currentlySelectedstyle={currentlySelectedstyle}
          feedContainerStyle={feedContainerStyle}
          feedInnerContainerStyle={feedInnerContainerStyle}
          selectedItems={selectedItems}
          isMultiSelect={isMultiSelect}
          isUnitFlow={isUnitFlow}
          currentUnitFlowSection={currentUnitFlowSection}
          updateSelectedItems={updateSelectedItems}
          showCardWithStaffProfile={showCardWithStaffProfile}
          feedItemTitleStyle={feedItemTitleStyle}
          staffProfileImageStyle={staffProfileImageStyle}
          staffNameStyle={staffNameStyle}
          showCheckBox={showCheckBox}
          updateCurrentUnitFlowSection={updateCurrentUnitFlowSection}
          headerTabContainerStyle={headerTabContainerStyle}
          customRef={customCallbackRef}
          showSearchChip={showSearchChip}
          parentResourceId={parentResourceId}
          isEyePreviewEnabled={isEyePreviewEnabled}
          importFromToddleLibrary={importFromToddleLibrary}
          feedDataListContainerStyle={feedDataListContainerStyle}
          displayCountHeadingWithFilters={displayCountHeadingWithFilters}
          displayCountHeadingWithSearch={displayCountHeadingWithSearch}
          setTotalPostsCount={setTotalPostsCount}
          setWorksheetItem={setWorksheetItem}
          allGrades={allGrades}
          showResources={showResources}
          filtersInfo={filtersInfo}
          defaultPostType={defaultPostType}
          groupType={groupType}
          titleTextStyle={titleTextStyle}
          staffDetailsStyle={staffDetailsStyle}
          profileImageContainerProps={profileImageContainerProps}
          shouldShowWorksheet={shouldShowWorksheet}
        />
      </div>
    );
  }
);

LeFeed.displayName = "LeFeed";

LeFeed.propTypes = {
  testId: PropTypes.string,
  showHeaderText: PropTypes.bool,
  feedConStyle: PropTypes.object,
};

LeFeed.defaultProps = {
  testId: "appComponents",
  showHeaderText: true,
  feedConStyle: {},
  feedAsPosts: false,
  importFromLeLibrary: false,
  shouldIncludeQuickTasks: true,
  isMultiSelect: false,
  showCardWithStaffProfile: false,
  showCheckBox: true,
};

const withFilters = WrappedComponent => {
  return function WithFilters(props) {
    const { importFromToddleLibrary } = props;

    const EnhancedComponent = useMemo(() => {
      return importFromToddleLibrary
        ? withToddleLibraryFilters(WrappedComponent)
        : withLELibraryFilters(WrappedComponent);
    }, [importFromToddleLibrary]);

    return <EnhancedComponent {...props} />;
  };
};

export default compose(
  I18nHOC({ resource: ["common", "community", "snp", "classPlanner"] }),
  withFilters
)(LeFeed);
